<template>
  <div>
    <el-row class="mgb">
      <el-col :span="8">
        <span class="label">采购员</span>
        <span class="value">{{detailData.buyer | defaultShow}}</span>
      </el-col>
      <el-col :span="8">
        <span class="label">供应商联系人</span>
        <span class="value">{{detailData.contact | defaultShow}}</span>
      </el-col>
      <el-col :span="8">
        <span class="label">联系人电话</span>
        <span class="value">{{detailData.contactPhone | defaultShow}}</span>
      </el-col>
    </el-row>
    <div class="mgb">
      <span class="label">供应商地址</span>
      <span class="value">{{detailData.addr | defaultShow}}</span>
    </div>
    <el-row class="mgb">
      <el-col :span="8">
        <span class="label">QQ</span>
        <span class="value">{{detailData.qq | defaultShow}}</span>
      </el-col>
      <el-col :span="8">
        <span class="label">邮箱</span>
        <span class="value">{{detailData.email | defaultShow}}</span>
      </el-col>
      <el-col :span="8">
        <span class="label">传真</span>
        <span class="value">{{detailData.fax | defaultShow}}</span>
      </el-col>
    </el-row>
    <div class="mgb">
      <span class="label">公司网址</span>
      <span class="value">{{detailData.website | defaultShow}}</span>
    </div>
    <div class="mgb">
      <span class="label">备注</span>
      <span class="value">{{detailData.memo | defaultShow}}</span>
    </div>
    <div class="mgb">
      <span class="label">结算方式</span>
      <span class="value">{{settlementTypeMap !== null && isMeaningful(detailData.settlementWay) && settlementTypeMap[detailData.settlementWay].text}}</span>
    </div>
    <div class="mgb">
      <span class="label">结算备注</span>
      <span class="value">{{detailData.settlementMemo | defaultShow}}</span>
    </div>
  </div>
</template>

<script>

  import {isMeaningfulMixin} from "../../../../../minxins";

  export default {
    name: "app-supplier-detail-basic",
    mixins: [isMeaningfulMixin],
    props: {
      detailData: null,
      settlementTypeMap: null,
    },
  }
</script>

<style scoped>
  .label {
    color: #666;
    display: inline-block;
    width: 82px;
    text-align: right;
    padding-right: 10px;
  }

  .value {
    color: #333;
  }

  .mgb {
    margin-bottom: 12px;
  }
</style>
